import React from 'react';
import classNames from 'classnames';
import { Field, Form } from 'react-final-form';
import { Button, Loader } from 'ncoded-component-library';
import PasswordField from 'components/PasswordField';
import ArrowleftIcon from 'icons/Arrowleft.icon';
import useValidations from 'router/subrouters/Auth/hooks/useValidations';
import { useTranslation } from 'react-i18next';

import './MemberPassword.styles.scss';
import './MemberPassword.styles.responsive.scss';

type MemberPasswordProps = {
  className?: string;
  onBack: () => void;
  onSubmit: (values: { password: string }) => Promise<void>;
};

const MemberPassword: React.FC<MemberPasswordProps> = (props) => {
  const { className, onBack, onSubmit } = props;

  const classes = classNames('member-password', className);

  const commonValidations = useValidations();

  const { t } = useTranslation();

  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit, submitting }) => {
        return (
          <form onSubmit={handleSubmit} className={classes}>
            {submitting && <Loader overlay={false} />}

            <h1>{t('createPassword')}</h1>

            <Field
              name="password"
              label={t('password')}
              component={PasswordField}
              validate={commonValidations.password}
              required
            />

            <div className="actions">
              <Button variant="link" icon={ArrowleftIcon} onClick={onBack}>
                {t('back')}
              </Button>
              <Button type="submit">{t('save')}</Button>
            </div>
          </form>
        );
      }}
    />
  );
};

export default MemberPassword;
